import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { logout } from 'contexts/actions/authActions';
import { useUserState, useUserStateDispatch } from 'contexts/auth-context';

import trackingEvent from 'utils/trackingEvent';

import { BtnDropCircle } from 'components/common/Elements/Elements';
import cn from 'classnames';

import { userMenu } from 'data/dropDownConfig';

import classes from './UserDropdown.module.scss';

const UserDropdown = ({ className, mixpanel }) => {
  const username = useUserState().user.username;

  // const { auth } = useUserState();
  const dispatch = useUserStateDispatch();
  // const { user } = auth;

  let history = useHistory();

  const onSubmit = () => {
    logout()(dispatch);
  };

  const onSelectOptionUser = action => {
    if (action === 'account') {
      trackingEvent('user_setting', mixpanel, username);
      if (history.location.pathname !== `/userprofile`) {
        history.push(`/userprofile`);
      }
    } else if (action === 'exit') {
      trackingEvent('user_logout', mixpanel, username);
      onSubmit();
    }
  };

  return (
    <div className={cn(classes.base, className)}>
      <BtnDropCircle
        icon={'Icn_Profile'}
        menuConfig={userMenu}
        selectOption={onSelectOptionUser}
        transparent
        rightDrop
      />
    </div>
  );
};

UserDropdown.propTypes = {
  className: PropTypes.string,
  mixpanel: PropTypes.object
};

export default UserDropdown;
